import _createForOfIteratorHelper from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

import { __awaiter, __rest } from "tslib";
import { parse, parseUrl } from 'query-string';
import _mount from './mount';
import loadConfig from './utils/loadConfig';
import { buildUrl, clearQueryString } from './utils/queryString';
import openLinkAsync from './utils/openLinkAsync';
import { createDataStorage } from './utils/DataStorage';
import AuthProcessor from './AuthProcessor';

var getInstanceVariant = function getInstanceVariant(variant, wtExchange) {
  return wtExchange ? "wt:".concat(variant) : variant;
};

var INSTANCES_KEY = '__TxAuthWidgetInstances';
var INSTANCES_PROMISES_KEY = '__TxAuthWidgetInstancesPromises';

if (!window[INSTANCES_KEY]) {
  window[INSTANCES_KEY] = {
    prod: {},
    dev: {},
    preprod: {}
  };
}

if (!window[INSTANCES_PROMISES_KEY]) {
  window[INSTANCES_PROMISES_KEY] = {
    prod: {},
    dev: {},
    preprod: {}
  };
}

var TxAuthWidget = /*#__PURE__*/function () {
  function TxAuthWidget(options) {
    var _this = this;

    _classCallCheck(this, TxAuthWidget);

    this.jwtSubscribers = [];
    this.loginErrorSubscribers = [];
    this.logoutSubscribers = [];
    this.lastJwt = null;

    this.logout = function () {
      return _this.authProcessor.logout();
    };

    this.authorize = function (req) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setProvider(req.provider);

              case 2:
                return _context.abrupt("return", this.authProcessor.authorize(req));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };

    this.authorizeAnonymously = function () {
      return _this.authorize({
        provider: 'DEVICE_ID',
        login: '',
        password: ''
      });
    };

    this.authorizeWithToken = function (token, receiveTime, provider) {
      return _this.authProcessor.authorizeWithToken(token, receiveTime, provider);
    };

    this.isLoggedIn = function () {
      return _this.authProcessor.isLoggedIn();
    };

    this.getUserId = function () {
      return _this.dataStorage.getUserId();
    };

    this.getTokenProvider = function () {
      return _this.authProcessor.getTokenProvider();
    };

    this.forceRenew = function () {
      return _this.authProcessor.forceRenew();
    };

    this.getDeviceLocalId = function () {
      return _this.dataStorage.getLocalId(_this.appName);
    };

    this.getLastLoginProvider = function () {
      return _this.dataStorage.getLastLoginProvider();
    };

    this.oneTimeToken = function (providerId) {
      var _a;

      return _this.authProcessor.oneTimeToken(providerId || ((_a = _this.provider) === null || _a === void 0 ? void 0 : _a.id));
    };

    this.handleMessage = function (appName, provider, token, receiveTime) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _a, tokenProvider, prevToken;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!token) {
                  _context2.next = 17;
                  break;
                }

                if (!(this.appName && this.provider && this.appName === appName && this.provider.id === provider)) {
                  _context2.next = 12;
                  break;
                }

                tokenProvider = this.authProcessor.getTokenProvider();
                prevToken = tokenProvider.getToken();
                _context2.next = 6;
                return tokenProvider.setToken(token, receiveTime);

              case 6:
                if (document.hidden) {
                  tokenProvider.stopRenew();
                }

                if (prevToken) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 10;
                return this.changeToken(tokenProvider.buildResponse());

              case 10:
                _context2.next = 15;
                break;

              case 12:
                if (this.isLoggedIn()) {
                  _context2.next = 15;
                  break;
                }

                _context2.next = 15;
                return this.authProcessor.tryAuthorizeWithExchangeToken({
                  fromAppName: appName,
                  toProvider: (_a = this.provider) === null || _a === void 0 ? void 0 : _a.id
                });

              case 15:
                _context2.next = 20;
                break;

              case 17:
                if (!(this.appName && this.provider && this.appName === appName && this.provider.id === provider)) {
                  _context2.next = 20;
                  break;
                }

                _context2.next = 20;
                return this.authProcessor.logout();

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    };

    this.handleLoginResponse = function (response, newProvider) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _b, _c, _d, _e, newUserId, prevUserId, token;

        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!response.confirmation.enable) {
                  _context3.next = 4;
                  break;
                }

                if (newProvider) {
                  this.provider = newProvider;
                }

                this.confirmation = response.confirmation;
                return _context3.abrupt("return");

              case 4:
                if (!response.provider.startsWith('OAUTH2')) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return");

              case 6:
                if (!newProvider) {
                  _context3.next = 13;
                  break;
                }

                this.provider = newProvider;
                newUserId = (_b = response.session.person) === null || _b === void 0 ? void 0 : _b.id;
                prevUserId = this.dataStorage.getUserId();

                if (!(newUserId && newUserId !== prevUserId)) {
                  _context3.next = 13;
                  break;
                }

                _context3.next = 13;
                return this.dataStorage.logout();

              case 13:
                if (this.provider) {
                  _context3.next = 15;
                  break;
                }

                return _context3.abrupt("return");

              case 15:
                this.confirmation = undefined;
                this.dataStorage.setLastLoginProvider(response.provider);
                this.dataStorage.setLastUserInfo({
                  provider: response.provider,
                  login: (_c = response.session.person) === null || _c === void 0 ? void 0 : _c.login,
                  name: ((_d = response.session.person) === null || _d === void 0 ? void 0 : _d.name) || ((_e = response.session.person) === null || _e === void 0 ? void 0 : _e.login)
                });
                token = response ? response.token : null;
                _context3.next = 21;
                return Promise.all([this.dataStorage.setToken(this.appName, this.provider.id, token, response === null || response === void 0 ? void 0 : response.receiveTime), this.changeToken(response)]);

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    };

    this.handleChangeNotCurrentToken = function (res, provider) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var token;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                token = res ? res.token : null;
                _context4.next = 3;
                return this.dataStorage.setToken(this.appName, provider, token, res === null || res === void 0 ? void 0 : res.receiveTime);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    };

    this.handleLogout = function () {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(this.provider && this.dataStorage.getToken(this.appName, this.provider.id))) {
                  _context5.next = 3;
                  break;
                }

                _context5.next = 3;
                return this.dataStorage.logout();

              case 3:
                this.logoutSubscribers.forEach(function (s) {
                  return s();
                });
                _context5.next = 6;
                return this.changeToken(null);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    };

    this.changeToken = function (res) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var wasNotLoggedIn, _iterator, _step, subscriber, _ref, onLoginSuccess;

        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                wasNotLoggedIn = !this.lastJwt;
                this.lastJwt = res; // eslint-disable-next-line no-restricted-syntax

                _iterator = _createForOfIteratorHelper(this.jwtSubscribers);
                _context6.prev = 3;

                _iterator.s();

              case 5:
                if ((_step = _iterator.n()).done) {
                  _context6.next = 11;
                  break;
                }

                subscriber = _step.value;
                _context6.next = 9;
                return subscriber(res, this.options.variant);

              case 9:
                _context6.next = 5;
                break;

              case 11:
                _context6.next = 16;
                break;

              case 13:
                _context6.prev = 13;
                _context6.t0 = _context6["catch"](3);

                _iterator.e(_context6.t0);

              case 16:
                _context6.prev = 16;

                _iterator.f();

                return _context6.finish(16);

              case 19:
                if (res && wasNotLoggedIn) {
                  _ref = this.options.events || {}, onLoginSuccess = _ref.onLoginSuccess;
                  onLoginSuccess && onLoginSuccess(res);
                }

              case 20:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[3, 13, 16, 19]]);
      }));
    };

    this.handleLoginError = function (error) {
      _this.loginErrorSubscribers.forEach(function (s) {
        return s(error);
      });

      var _ref2 = _this.options.events || {},
          onLoginError = _ref2.onLoginError;

      onLoginError && onLoginError(error);
    };

    this.env = options.env;
    this.appName = options.appName;
    this.appVersion = options.appVersion;
    this.options = options;
  }

  _createClass(TxAuthWidget, [{
    key: "dispose",
    value: function dispose() {
      var _a, _b;

      (_a = this.authProcessor) === null || _a === void 0 ? void 0 : _a.dispose();
      this.unmount();
      (_b = this.dataStorage) === null || _b === void 0 ? void 0 : _b.dispose();
    }
  }, {
    key: "getEnv",
    value: function getEnv() {
      return this.env;
    }
  }, {
    key: "getAppName",
    value: function getAppName() {
      return this.appName;
    }
  }, {
    key: "init",
    value: function init(config) {
      var _a, _b, _c, _d, _e, _f;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this2 = this;

        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.config = config;
                this.authProcessor = new AuthProcessor(config.services, {
                  env: this.env,
                  variant: this.options.variant,
                  appName: this.appName,
                  appVersion: this.appVersion,
                  providers: this.providers,
                  tokenScope: this.options.scope,
                  renewMethodType: config.renewMethodType || 'unary',
                  setLocalId: this.dataStorage.setLocalId,
                  getLocalId: this.dataStorage.getLocalId,
                  setNotYourComputer: typeof config.notYourComputer === 'boolean' ? this.dataStorage.setNotYourComputer : undefined,
                  hasTokensForExchange: this.options.wtExchange ? function () {
                    return false;
                  } : this.dataStorage.hasTokens,
                  getToken: function getToken(appName, provider) {
                    return _this2.dataStorage.getToken(appName, provider);
                  },
                  onTokenRenewTimeout: (_a = this.options.events) === null || _a === void 0 ? void 0 : _a.onTokenRenewTimeout,
                  onChangeToken: this.handleLoginResponse,
                  onChangeNotCurrentToken: this.handleChangeNotCurrentToken,
                  onLoginError: this.handleLoginError,
                  onRegistrationSuccess: (_b = this.options.events) === null || _b === void 0 ? void 0 : _b.onRegistrationSuccess,
                  onRegistrationWatch: (_c = this.options.events) === null || _c === void 0 ? void 0 : _c.onRegistrationWatch,
                  onRegistrationError: (_d = this.options.events) === null || _d === void 0 ? void 0 : _d.onRegistrationError,
                  onLogout: this.handleLogout
                });
                this.initProvider();
                _context7.prev = 3;

                if (!this.options.parseUrl) {
                  _context7.next = 9;
                  break;
                }

                _context7.next = 7;
                return this.tryAuthorizeByQuery((_e = this.provider) === null || _e === void 0 ? void 0 : _e.id);

              case 7:
                _context7.next = 11;
                break;

              case 9:
                _context7.next = 11;
                return this.authProcessor.tryAuthorizeByProvider((_f = this.provider) === null || _f === void 0 ? void 0 : _f.id);

              case 11:
                _context7.next = 16;
                break;

              case 13:
                _context7.prev = 13;
                _context7.t0 = _context7["catch"](3);
                console.warn(_context7.t0);

              case 16:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[3, 13]]);
      }));
    }
  }, {
    key: "tryAuthorizeByQuery",
    value: function tryAuthorizeByQuery(providerParam) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _this3 = this;

        var resetProviderIfExists, parseProviderIdFromToken, _a, tokenQuery, providerQuery, login, password, ott, queryParams, storedProviderQueryToken, provider, tokenQueryProvider, tokenParam;

        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (this.options.parseUrl) {
                  _context8.next = 2;
                  break;
                }

                return _context8.abrupt("return");

              case 2:
                resetProviderIfExists = function resetProviderIfExists(providerId) {
                  var nextProvider = providerId && _this3.providers.find(function (p) {
                    return p.id === providerId;
                  });

                  if (nextProvider) {
                    _this3.provider = nextProvider;
                  }
                };

                parseProviderIdFromToken = function parseProviderIdFromToken(token) {
                  var _a;

                  var providerFromToken;

                  try {
                    providerFromToken = (_a = JSON.parse(atob(token.split('.')[1]))) === null || _a === void 0 ? void 0 : _a.provider;
                  } catch (err) {
                    console.warn('Failed to parse provider from token');
                  }

                  return providerFromToken;
                };

                _a = parse(window.location.search), tokenQuery = _a.token, providerQuery = _a.provider, login = _a.login, password = _a.password, ott = _a.ott, queryParams = __rest(_a, ["token", "provider", "login", "password", "ott"]);

                if (!this.options.preserveQueryParams && (tokenQuery || providerQuery || login || password || ott)) {
                  clearQueryString(queryParams);
                }

                storedProviderQueryToken = this.dataStorage.getToken(this.appName, providerQuery);
                provider = providerQuery || providerParam;

                if (!(provider && login && password)) {
                  _context8.next = 14;
                  break;
                }

                resetProviderIfExists(providerQuery);
                _context8.next = 12;
                return this.authProcessor.authorize({
                  login: login.toString(),
                  password: password.toString(),
                  provider: provider.toString(),
                  noHash: true
                });

              case 12:
                _context8.next = 43;
                break;

              case 14:
                if (!ott) {
                  _context8.next = 20;
                  break;
                }

                resetProviderIfExists(providerQuery);
                _context8.next = 18;
                return this.authProcessor.exchangeOneTimeToken(ott.toString(), providerQuery);

              case 18:
                _context8.next = 43;
                break;

              case 20:
                if (!tokenQuery) {
                  _context8.next = 28;
                  break;
                }

                tokenQueryProvider = parseProviderIdFromToken(tokenQuery);

                if (tokenQueryProvider) {
                  this.dataStorage.setToken(this.appName, tokenQueryProvider, null);
                }

                resetProviderIfExists(tokenQueryProvider || provider);
                _context8.next = 26;
                return this.authorizeWithToken(tokenQuery, undefined, tokenQueryProvider || provider);

              case 26:
                _context8.next = 43;
                break;

              case 28:
                if (!(providerQuery && storedProviderQueryToken)) {
                  _context8.next = 34;
                  break;
                }

                resetProviderIfExists(providerQuery);
                _context8.next = 32;
                return this.authProcessor.authorizeWithToken(storedProviderQueryToken.token, storedProviderQueryToken.receiveTime, providerQuery);

              case 32:
                _context8.next = 43;
                break;

              case 34:
                tokenParam = providerParam && this.dataStorage.getToken(this.appName, providerParam);

                if (!tokenParam) {
                  _context8.next = 40;
                  break;
                }

                _context8.next = 38;
                return this.authProcessor.authorizeWithToken(tokenParam.token, tokenParam.receiveTime);

              case 38:
                _context8.next = 43;
                break;

              case 40:
                resetProviderIfExists(providerQuery);
                _context8.next = 43;
                return this.authProcessor.tryAuthorizeWithExchangeToken({
                  toProvider: provider
                });

              case 43:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "initProviders",
    value: function initProviders(_initProviders, configProviders) {
      this.availableProviders = configProviders;
      var providers = _initProviders.length > 0 ? configProviders.filter(function (p) {
        return _initProviders.indexOf(p.id) !== -1;
      }) : configProviders.filter(function (p) {
        return p.default;
      });

      if (providers.length === 0) {
        throw new Error('providers not available');
      }

      this.providers = providers;
    }
  }, {
    key: "initProvider",
    value: function initProvider() {
      var _this4 = this;

      if (this.providers.length === 1) {
        this.provider = this.providers[0];
        return;
      }

      var providersWithToken = this.providers.filter(function (p) {
        return !!_this4.dataStorage.getToken(_this4.appName, p.id);
      });
      var lastLoginProvider = this.dataStorage.getLastLoginProvider();
      this.provider = providersWithToken.length > 1 ? lastLoginProvider ? providersWithToken.find(function (p) {
        return p.id === lastLoginProvider;
      }) : undefined : providersWithToken[0];
    }
  }, {
    key: "subscribeJWT",
    value: function subscribeJWT(callback) {
      var _this5 = this;

      this.jwtSubscribers.push(callback);
      callback(this.lastJwt, this.options.variant);
      return function () {
        return _this5.jwtSubscribers.splice(_this5.jwtSubscribers.indexOf(callback), 1);
      };
    }
  }, {
    key: "subscribeOnLoginError",
    value: function subscribeOnLoginError(callback) {
      var _this6 = this;

      this.loginErrorSubscribers.push(callback);
      return function () {
        return _this6.loginErrorSubscribers.splice(_this6.loginErrorSubscribers.indexOf(callback), 1);
      };
    }
  }, {
    key: "subscribeOnLogout",
    value: function subscribeOnLogout(callback) {
      var _this7 = this;

      this.logoutSubscribers.push(callback);
      return function () {
        return _this7.logoutSubscribers.splice(_this7.logoutSubscribers.indexOf(callback), 1);
      };
    }
  }, {
    key: "getProviders",
    value: function getProviders() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var serviceProviders;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.authProcessor.getProviders();

              case 2:
                serviceProviders = _context9.sent;
                return _context9.abrupt("return", this.availableProviders.filter(function (p) {
                  return serviceProviders.indexOf(p.id) !== -1;
                }));

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "setProvider",
    value: function setProvider(providerId) {
      var _a;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!(((_a = this.provider) === null || _a === void 0 ? void 0 : _a.id) === providerId)) {
                  _context10.next = 2;
                  break;
                }

                return _context10.abrupt("return");

              case 2:
                this.provider = this.providers.find(function (p) {
                  return p.id === providerId;
                });

                if (this.provider) {
                  _context10.next = 5;
                  break;
                }

                throw new Error('provider is not defined');

              case 5:
                this.lastJwt = null;
                this.confirmation = undefined;
                this.authProcessor.getTokenProvider().stopRenew();
                this.authProcessor.getTokenProvider().removeToken();
                _context10.prev = 9;
                _context10.next = 12;
                return this.authProcessor.tryAuthorizeByProvider(providerId);

              case 12:
                _context10.next = 17;
                break;

              case 14:
                _context10.prev = 14;
                _context10.t0 = _context10["catch"](9);
                console.warn(_context10.t0);

              case 17:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[9, 14]]);
      }));
    }
  }, {
    key: "getProvider",
    value: function getProvider() {
      return this.provider;
    }
  }, {
    key: "setRegistrationData",
    value: function setRegistrationData(registrationData) {
      this.registrationData = registrationData;
    }
  }, {
    key: "mount",
    value: function mount(element) {
      var _this8 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _a, _b;

      if (!this.provider) {
        throw new Error('provider not defined');
      }

      var lastLoginInfo = this.dataStorage.getLastUserInfo(this.options.variant);
      var hostPreferenceNotYourComputer = this.dataStorage.getNotYourComputer();
      var appDefaultNotYourComputer = (_a = this.config) === null || _a === void 0 ? void 0 : _a.notYourComputer; // Данный оператор гарантирует, что в LocalStorage будет лежать значение
      // notYourComputer только в том случае, если оно поддерживается приложением

      if (typeof appDefaultNotYourComputer !== 'boolean') {
        this.dataStorage.setNotYourComputer(undefined);
        hostPreferenceNotYourComputer = undefined;
      }

      this.unmountFn = _mount(element, {
        lang: options.lang || this.options.lang || 'ru',
        theme: options.theme || this.options.theme,
        variant: this.options.variant,
        provider: this.provider,
        confirmation: this.confirmation,
        lastLoginInfo: this.provider.use_last_login && lastLoginInfo && lastLoginInfo.provider === this.provider.id && lastLoginInfo.login ? lastLoginInfo : null,
        title: options.title || this.options.title,
        uiSettings: options.uiSettings || this.options.uiSettings,
        qr: this.options.qr,
        registration: this.options.registration && this.provider.registration && this.authProcessor.registrationAvailable,
        recoveryLink: (_b = this.provider) === null || _b === void 0 ? void 0 : _b.recoveryLink,
        initialNotYourComputer: hostPreferenceNotYourComputer !== null && hostPreferenceNotYourComputer !== void 0 ? hostPreferenceNotYourComputer : appDefaultNotYourComputer,
        registrationData: options.registrationData || this.registrationData,
        oAuthSources: this.options.oAuthSources,
        authProcessor: this.authProcessor,
        config: this.config,
        onResetLastLogin: function onResetLastLogin() {
          _this8.dataStorage.setLastUserInfo(undefined);

          _this8.dataStorage.setNotYourComputer(undefined);
        }
      });
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var _this9 = this;

      this.confirmation = undefined;

      if (this.unmountFn) {
        var res = new Promise(function (resolve) {
          setTimeout(function () {
            _this9.unmountFn && _this9.unmountFn();
            _this9.unmountFn = undefined;
            resolve();
          });
        });
        return res;
      }

      return Promise.resolve();
    }
  }, {
    key: "openApp",
    value: function openApp(_ref3) {
      var _this10 = this;

      var providerId = _ref3.providerId,
          url = _ref3.url,
          target = _ref3.target,
          features = _ref3.features,
          loadingFallback = _ref3.loadingFallback;

      var _parseUrl = parseUrl(url),
          baseUrl = _parseUrl.url,
          query = _parseUrl.query;

      return openLinkAsync(function () {
        return __awaiter(_this10, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
          var ott;
          return _regeneratorRuntime().wrap(function _callee11$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  _context11.next = 2;
                  return this.oneTimeToken(providerId);

                case 2:
                  ott = _context11.sent;
                  return _context11.abrupt("return", buildUrl(baseUrl, Object.assign(Object.assign({}, query), {
                    ott: ott
                  })));

                case 4:
                case "end":
                  return _context11.stop();
              }
            }
          }, _callee11, this);
        }));
      }, target, features, loadingFallback);
    }
  }], [{
    key: "new",
    value: function _new(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var instanceVariant, widgetPromise;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!options.env) {
                  options.env = 'prod';
                }

                instanceVariant = getInstanceVariant(options.variant, options.wtExchange);

                if (!this.instances[options.env][instanceVariant]) {
                  _context12.next = 4;
                  break;
                }

                throw Error('TxAuthWidget is already created');

              case 4:
                if (!this.instancesPromises[options.env][instanceVariant]) {
                  _context12.next = 6;
                  break;
                }

                throw Error('TxAuthWidget is already creating');

              case 6:
                _context12.prev = 6;
                widgetPromise = this.create(options);
                this.instancesPromises[options.env][instanceVariant] = widgetPromise;
                _context12.next = 11;
                return widgetPromise;

              case 11:
                return _context12.abrupt("return", _context12.sent);

              case 14:
                _context12.prev = 14;
                _context12.t0 = _context12["catch"](6);
                delete this.instances[options.env][instanceVariant];
                throw _context12.t0;

              case 18:
                _context12.prev = 18;
                delete this.instancesPromises[options.env][instanceVariant];
                return _context12.finish(18);

              case 21:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[6, 14, 18, 21]]);
      }));
    }
  }, {
    key: "create",
    value: function create(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var instance, instanceVariant, config, optionProviders;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                instance = new TxAuthWidget(options);
                instanceVariant = getInstanceVariant(options.variant, options.wtExchange);
                this.instances[instance.env][instanceVariant] = instance;
                _context13.t0 = Object;
                _context13.t1 = Object;
                _context13.t2 = {};
                _context13.next = 8;
                return loadConfig(instance.env, options.variant);

              case 8:
                _context13.t3 = _context13.sent;
                _context13.t4 = _context13.t1.assign.call(_context13.t1, _context13.t2, _context13.t3);
                _context13.t5 = options.config;
                config = _context13.t0.assign.call(_context13.t0, _context13.t4, _context13.t5);
                // eslint-disable-next-line no-nested-ternary
                optionProviders = options.provider ? Array.isArray(options.provider) ? options.provider : [options.provider] : [];
                instance.initProviders(optionProviders, config.providers);
                _context13.next = 16;
                return createDataStorage({
                  env: instance.env,
                  variant: options.variant,
                  appName: options.appName,
                  scope: options.scope,
                  useHostStorage: options.wtExchange,
                  keysPrefix: options.wtExchange ? 'wt-local' : undefined,
                  providers: instance.providers
                });

              case 16:
                instance.dataStorage = _context13.sent;
                instance.dataStorage.onChange = instance.handleMessage;
                _context13.next = 20;
                return instance.init(config);

              case 20:
                return _context13.abrupt("return", instance);

              case 21:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
    }
  }, {
    key: "getOrCreate",
    value: function getOrCreate(options) {
      if (!options.env) {
        options.env = 'prod';
      }

      var env = options.env,
          variant = options.variant,
          wtExchange = options.wtExchange;
      var instanceVariant = getInstanceVariant(variant, wtExchange);
      var instance = this.instances[env][instanceVariant];

      if (instance) {
        if (JSON.stringify(options) !== JSON.stringify(instance.options)) {
          throw new Error('the widget is already created for this variant with other options');
        }

        var instancePromise = this.instancesPromises[env][instanceVariant];

        if (instancePromise) {
          return instancePromise;
        }

        return Promise.resolve(instance);
      }

      return this.new(options);
    }
  }, {
    key: "getInstance",
    value: function getInstance(variant) {
      var env = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'prod';
      var wtExchange = arguments.length > 2 ? arguments[2] : undefined;
      var instanceVariant = getInstanceVariant(variant, wtExchange);
      var instance = this.instances[env][instanceVariant];

      if (!instance) {
        throw new Error('call new before getInstance');
      }

      return instance;
    }
  }, {
    key: "destroy",
    value: function destroy(variant) {
      var _this11 = this;

      var env = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'prod';
      var wtExchange = arguments.length > 2 ? arguments[2] : undefined;
      var instanceVariant = getInstanceVariant(variant, wtExchange);
      var instancePromise = this.instancesPromises[env][instanceVariant];

      if (instancePromise) {
        return instancePromise.then(function (widget) {
          widget.dispose();
          delete _this11.instancesPromises[env][instanceVariant];
          delete _this11.instances[env][instanceVariant];
        });
      }

      var instance = this.instances[env][instanceVariant];

      if (instance) {
        instance.dispose();
        delete this.instances[env][instanceVariant];
      }

      return undefined;
    }
  }]);

  return TxAuthWidget;
}();

export { TxAuthWidget as default };
TxAuthWidget.instances = window[INSTANCES_KEY];
TxAuthWidget.instancesPromises = window[INSTANCES_PROMISES_KEY];